import { CategoryTypes, postValidationSchema } from '@bakbak/common';
import { CreatePostMutation_createPost } from "@bakbak/controller";
import { Button, Form, Select } from "antd";
import { Field, Form as FForm, FormikProps, withFormik } from "formik";
import * as React from "react";
import * as Recaptcha from 'react-recaptcha';
import { THEME_COLOR } from "../../../constants";
import { InputField } from "../../../util/InputField";
import { TagField } from "../../../util/TagField";



const FormItem = Form.Item;
const Option = Select.Option;

interface FormValues {
  title: string;
  details: string;
  categories: string;
}
interface SubmitValues {
  title: string;
  details: string;
  categories: string[];
}
interface Props {
  onComplete: () => void;
  onCancel: () => void;
  submit: (
    values: SubmitValues,
  ) => Promise<CreatePostMutation_createPost | null>;
}

const children: any = [];
CategoryTypes.map(category => {
  children.push(<Option key={category}> {category} </Option>);
});

interface State {
  recaptchaSuccess: boolean;
}

class CreatePostForm extends React.PureComponent<FormikProps<FormValues> & Props, State> {
  state = { recaptchaSuccess: false };

  verifyRecaptcha = (response: any) => {
    this.setState(() => ({ recaptchaSuccess: true }));
  }
  render() {
    return (
      <FForm style={{ display: "flex" }}>
        <div style={{ width: 400, margin: "auto", marginTop: 50 }}>
          <Field
            name="title"
            placeholder="title goes here"
            component={InputField}
            multiLine={true}
            minRows={2}
            maxRows={5}
          />
          Select a Category:
          <Field
            name="categories"
            placeholder="Select Category"
            component={TagField}
            children={children}
          />
          <Field
            name="details"
            placeholder="details of the post"
            component={InputField}
            multiLine={true}
            minRows={3}
            maxRows={5}
          />
          <Recaptcha
            sitekey="6Lc7DIYUAAAAAI2HOLsOgT7QUa8LUI87zqgU2-8Z"
            render="explicit"
            verifyCallback={this.verifyRecaptcha}
          />
          <FormItem>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
              <Button disabled={!this.state.recaptchaSuccess} htmlType="submit" style={{
                width: '40%', backgroundColor: THEME_COLOR, color: 'white', borderColor: THEME_COLOR
              }}>
                Create Post
							</Button>
              <Button onClick={this.props.onCancel} style={{
                width: '40%', backgroundColor: 'Grey', color: 'white', borderColor: 'grey'
              }}>
                Cancel
							</Button>
            </div>
          </FormItem>
        </div>
      </FForm>
    );
  }
}

export const CreatePostView = withFormik<Props, FormValues>({
  validationSchema: postValidationSchema,
  mapPropsToValues: () => ({ title: "", details: "", categories: "" }),
  handleSubmit: async (values, { props, setErrors }) => {
    const valuesSubmit = { ...values, categories: [values.categories] }
    const response = await props.submit(valuesSubmit);
    if (response && response.errors) {
      setErrors(response.errors as any);
    } else {
      props.onComplete();
    }
  }
})(CreatePostForm);



// WEBPACK FOOTER //
// ./src/modules/post/create/CreatePostView.tsx